import { render, staticRenderFns } from "./List.vue?vue&type=template&id=5320c8bc&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"
import style0 from "./List.vue?vue&type=style&index=0&id=5320c8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5320c8bc",
  null
  
)

export default component.exports